import { ReactNode } from 'react';

import { Container } from 'components/Container';

import { StyledTable, Td } from './Table.styled';

type Props = {
  'data-qa-id'?: string;
  headings: Array<ReactNode>;
  headingTitles?: Array<string>;
  trQaId?: string;
  data: Array<Array<ReactNode>> | Array<ReactNode>;
  simple?: boolean;
  hideHead?: boolean;
  fixed?: boolean;
  lastColumnAction?: boolean;
  initialIndex?: number;
  widths?: Array<number | string>;
  continuousHeaderBorder?: boolean;
};

export function Table({
  headings,
  headingTitles,
  data,
  trQaId,
  simple,
  hideHead,
  fixed,
  lastColumnAction,
  continuousHeaderBorder,
  initialIndex = 0,
  widths = [],
  ...props
}: Props) {
  return (
    <Container py={[0, 0, 0, '12px']}>
      <StyledTable
        $simple={simple}
        $continuousHeaderBorder={continuousHeaderBorder}
        $widths={widths}
        // @ts-expect-error TS(2769): No overload matches this call.
        $fixed={fixed}
        $lastColumnAction={lastColumnAction}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {!hideHead && (
          <thead>
            <tr>
              {headings.map((heading, index) => (
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/no-array-index-key
                <th key={index}>{heading}</th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {data.map((row, rindex) => (
            <tr // eslint-disable-next-line react/no-array-index-key
              key={rindex}
              data-qa-id={trQaId}
              data-row-index={rindex + initialIndex}
            >
              {Array.isArray(row)
                ? row.map((cell, index) => {
                    const $heading = headingTitles
                      ? headingTitles[index]
                      : headings[index];

                    return (
                      <Td // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        $heading={typeof $heading === 'string' ? $heading : ''}
                      >
                        {cell}
                      </Td>
                    );
                  })
                : row}
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </Container>
  );
}
